import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorAssetUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M5.172 20.122a8.75 8.75 0 1 1 13.656 0h.816a.75.75 0 0 1 0 1.5H4.09a.75.75 0 0 1 0-1.5h1.083ZM4.75 14.65a7.25 7.25 0 1 1 12.006 5.472H7.244A7.231 7.231 0 0 1 4.75 14.65Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M4.545 1.093a.657.657 0 0 0-.93 0L1.592 3.116a.657.657 0 1 0 .93.93l.9-.901v4.144a.657.657 0 0 0 1.316 0V3.145l.9.9a.657.657 0 1 0 .93-.93L4.545 1.094ZM11.714 10.488c.154-.5.863-.5 1.018 0l.625 2.023h2.095c.51 0 .728.647.323.956l-1.717 1.312.642 2.077a.533.533 0 0 1-.833.581l-1.644-1.256-1.644 1.256a.533.533 0 0 1-.833-.58l.642-2.078-1.718-1.312a.533.533 0 0 1 .324-.956h2.095l.625-2.023ZM21.63 7.069v2.538a.607.607 0 1 1-1.214 0V7.07l-.734.734a.607.607 0 0 1-.858-.859l1.77-1.77a.607.607 0 0 1 .858 0l1.77 1.77a.607.607 0 1 1-.858.859l-.734-.734Z"
    />
  </svg>
);
export default SvgTwoColorAssetUp;
